<template>
  <BaseTableItemAction
    v-can:[viewPermission]
    v-on="$listeners"
    v-bind="$attrs"
    icon="mdi-eye"
    actionName="عرض"
    :to="'/news/' + this.item.id"
  >
    <slot></slot>
  </BaseTableItemAction>
</template>

<script>
import { READ_NEWS_PERMISSION } from "@/core/statics/Permissions";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      viewPermission: READ_NEWS_PERMISSION,
    };
  },
};
</script>
